export const SCORE_CARD_MESSAGES = {
  CREATED: 'The score card was successfully uploaded',
  NOT_FOUND_SCORING_LOGS: 'No scoring logs were found',
};


// WEBPACK FOOTER //
// ./src/features/score-card/constants/scoreCardMessages.js